import React, { useState, useEffect } from 'react'
import { FaDiscord } from 'react-icons/fa'

import DefaultLayout from '../../layouts/DefaultLayout'
import HomePresentation from '../../components/HomePresentation'
import PluginHeader from '../../components/PluginHeader'
import Categories from '../../components/Categories'
import PluginsList from '../../components/PluginsList'
import PartnersSection from '../../components/PartnersSection'
import AboutSection from '../../components/AboutSection'
import ContactSection from '../../components/ContactSection'

import { PluginSectionProvider } from '../../contexts/PluginSectionProvider'
import DiscordInviteBanner from '../../components/DiscordInviteBanner'

const DISCORD_MODAL_SEEN_KEY = 'discordBannerSeen'
const DISCORD_INVITE_LINK = 'https://discord.com/invite/J7MUSpC'

export default function Home() {
  const [isBannerVisible, setIsBannerVisible] = useState(false)

  useEffect(() => {
    const alreadySeen = sessionStorage.getItem(DISCORD_MODAL_SEEN_KEY)
    if (!alreadySeen) {
      const timer = setTimeout(() => {
        setIsBannerVisible(true)
        sessionStorage.setItem(DISCORD_MODAL_SEEN_KEY, 'true')
      }, 2500)

      return () => clearTimeout(timer)
    }
  }, [])

  const handleCloseBanner = () => {
    setIsBannerVisible(false)
  }

  return (
    <DefaultLayout title="Página Inicial" pageUrl="/">
      <HomePresentation />
      <PluginHeader />
      <PluginSectionProvider>
        <Categories />
        <PluginsList />
      </PluginSectionProvider>
      <PartnersSection />
      <AboutSection />
      <ContactSection />

      <DiscordInviteBanner 
        isVisible={isBannerVisible} 
        onClose={handleCloseBanner} 
        inviteLink={DISCORD_INVITE_LINK} 
      />
    </DefaultLayout>
  )
}
